module.exports = __webpack_public_path__ + "img/symbol_1.e273b736.png";